import type { Theme } from '@mui/material';
import {
  RICH_TEXT_HEADING_TAGS,
  RICH_TEXT_LARGE_SIZE,
  RICH_TEXT_LEGACY_MEDIUM_SIZE,
  RICH_TEXT_SIZE_ATTRIBUTE,
  RICH_TEXT_SIZE_TAG,
  RICH_TEXT_SMALL_SIZE,
  RICH_TEXT_UNDERLINE_TAG,
} from './richText.constants';

const toSizeSelector = (sizes: string[]) =>
  sizes.map((size) => `& ${RICH_TEXT_SIZE_TAG}[${RICH_TEXT_SIZE_ATTRIBUTE}="${size}"]`).join(', ');

export const getRichTextContentStyles = (theme: Theme) => ({
  [`& :is(${RICH_TEXT_HEADING_TAGS.join(', ')})`]: {
    fontSize: theme.typography.h4.fontSize,
    margin: theme.spacing(1, 0, 0.5),
  },
  [`& ${RICH_TEXT_UNDERLINE_TAG}`]: {
    textDecoration: 'underline',
    textDecorationThickness: '1px',
    textUnderlineOffset: '2px',
  },
  [toSizeSelector([RICH_TEXT_LARGE_SIZE, RICH_TEXT_LEGACY_MEDIUM_SIZE])]: {
    fontSize: theme.typography.h4.fontSize,
  },
  [toSizeSelector([RICH_TEXT_SMALL_SIZE])]: {
    fontSize: theme.typography.micro1.fontSize,
  },
  '& > :first-of-type': { marginTop: 0 },
});
